"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Base = require("./Base");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Filter = function Filter(_ref) {
  var column = _ref.column,
      data = _ref.data,
      filterValue = _ref.filterValue,
      handleFilterChange = _ref.handleFilterChange,
      inputRef = _ref.inputRef;
  var type = column.filter.type;
  var DynamicFilter = type === 'search' ? _Base.SearchFilter : _Base.SelectFilter;

  var renderOptions = function renderOptions() {
    var filterOptions = column.filter.options;

    if (typeof filterOptions === 'function') {
      filterOptions = filterOptions(data);
    }

    var options = filterOptions.map(function (opt) {
      var _opt = _slicedToArray(opt, 2),
          name = _opt[0],
          value = _opt[1];

      return _react.default.createElement("option", {
        value: value,
        key: value
      }, name);
    });
    return options;
  };

  return type === 'select' ? _react.default.createElement(_Base.SelectFilterWrapper, null, _react.default.createElement(DynamicFilter, {
    value: filterValue,
    onChange: function onChange(e) {
      return handleFilterChange(e.target.value);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    ref: inputRef
  }, renderOptions())) : _react.default.createElement(DynamicFilter, {
    placeholder: column.filter.placeholder,
    value: filterValue,
    onChange: function onChange(e) {
      return handleFilterChange(e.target.value);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    ref: inputRef
  });
};

Filter.defaultProps = {
  filterValue: ''
};
Filter.propTypes = {
  filterValue: _propTypes.default.string,
  handleFilterChange: _propTypes.default.func.isRequired,
  inputRef: _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  }).isRequired
};
var _default = Filter;
exports.default = _default;